import { utils } from './utils';
import { window } from '@wix/photography-client-lib';

try {
  if (!utils.isDev()) {
    // really annoying when in dev!!!
    const rcpSpanId = 'rcp-span';
    const rcpSpanStyle =
      'display:none; position:fixed;overflow:hidden;background-color: rgba(54,54,54,.4);border-radius:2px;color: #fff; padding: 3px 8px 3px 5px;font-family: HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;font-size:11px;z-index:9999';
    const rcpCopyrightsImage =
      '<img src="https://static.wixstatic.com/media/8bb438_890d19abb74245b6b55f558eecce22bf.png" alt="(c)" style="vertical-align: middle; -webkit-user-select: none;margin: 0;padding: 0;width: 14px;height:  14px; margin-right: 5px;">';

    const rcpScriptId = 'rcp-script';
    let rcpScript = "var rcpSpan = window.document.getElementById('rcp-span');";
    rcpScript +=
      "window.onmousemove = function (e) { var x = e.clientX, y = e.clientY; rcpSpan.style.top = (y + 20) + 'px'; rcpSpan.style.left = (x + 20) + 'px'; };";
    rcpScript +=
      "if (document.addEventListener) { window.document.addEventListener('contextmenu', function(e) { showCR(); e.preventDefault(); }, false); } else { window.document.attachEvent('oncontextmenu', function() { showCR(); window.event.returnValue = false; }); }";
    rcpScript +=
      "function showCR() { rcpSpan.style.display = 'block'; window.setTimeout(closeCR,2000); }";
    rcpScript += "function closeCR() { rcpSpan.style.display = 'none'; }";

    const rcpStyleId = 'rcp-style';
    const rcpStyle =
      'img {  pointer-events: none !important; user-select: none !important; -moz-user-select: none !important; -ms-user-select: none !important; -webkit-user-select: none !important; -webkit-touch-callout:none !important; -webkit-user-drag: none !important; -khtml-user-drag: none !important; -moz-user-drag: none !important; -o-user-drag: none !important; user-drag: none !important;}';

    if (!document.getElementById(rcpSpanId)) {
      const span = window.document.createElement('span');
      span.id = rcpSpanId;
      span.setAttribute('style', rcpSpanStyle);
      span.innerHTML = rcpCopyrightsImage;
      window.document.body.appendChild(span);
    }
    if (!document.getElementById(rcpScriptId)) {
      const script = window.document.createElement('script');
      script.id = rcpScriptId;
      script.type = 'text/javascript';
      script.innerHTML = rcpScript;
      window.document.body.appendChild(script);
    }
    if (!document.getElementById(rcpStyleId)) {
      const style = window.document.createElement('style');
      style.type = 'text/css';
      style.id = rcpStyleId;
      style.innerHTML = rcpStyle;
      window.document.head.appendChild(style);
    }
  }
} catch (e) {
  console.error('error in right click protection');
}
